import { render, staticRenderFns } from "./DetailNPPage.vue?vue&type=template&id=cbae9b5a&scoped=true&"
import script from "./DetailNPPage.vue?vue&type=script&lang=js&"
export * from "./DetailNPPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailNPPage.vue?vue&type=style&index=0&id=cbae9b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbae9b5a",
  null
  
)

export default component.exports